'use client';

import type React from 'react';
import { useEffect, useRef, useState } from 'react';
import './LocationMaps.scss';
import SettingConfig from '@module/config/setting';
import getUserAgentInfo from '@module/utils/user-agent/getUserAgentInfo';

const tapInterval = 300;

function LocationMaps() {
  const [lastTap, setLastTap] = useState<number>(0);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const { isMobile } = getUserAgentInfo();
    if (isMobile) {
      imgRef.current?.classList.add('scale-[3]');
    }
  }, []);

  const zoomin = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
    const tag = e.target as HTMLImageElement;
    if (tag.classList.contains('scale-[3]')) {
      tag.classList.remove('scale-[3]');
      return;
    }
    if (tag.classList.contains('scale-[1.5]')) {
      tag.classList.remove('scale-[1.5]');
      tag.classList.add('scale-[3]');
      return;
    }
    tag.classList.add('scale-[1.5]');
  };

  const handleTap = (e: React.TouchEvent<HTMLImageElement>) => {
    const currentTime = Date.now();

    if (currentTime - lastTap < tapInterval) {
      e.preventDefault();
      if (imgRef.current) {
        zoomin({ target: imgRef.current } as unknown as React.MouseEvent<HTMLImageElement, MouseEvent>);
      }
    }

    setLastTap(currentTime);
  };

  return (
    <div className='location-maps-containcer' id='law-location'>
      <div className='title'>오시는 길</div>
      <div className='map_view'>
        <div className='overflow-hidden'>
          <img
            ref={imgRef}
            className='duration-200'
            onDoubleClick={zoomin}
            onTouchStart={handleTap}
            alt='kakao map'
            src={`${SettingConfig.S3_BUCKET_URL}/img/law/company_map.png`}
            width={1034}
            height={780}
          />
        </div>
        <p className='text-[#555] text-lg'>
          주소 : 부산광역시 해운대구 센텀중앙로 97, 에이동 42층 및 34층 3410호 (재송동, 센텀스카이비즈)
        </p>
      </div>
    </div>
  );
}

export default LocationMaps;
